import React from 'react';
import PropTypes from 'prop-types';
import {Typography} from '@mui/material';
import {renderAmount} from '../../../../util';
import {StyledBodyCell, StyledTableRow} from '../components';
import {GREY_90} from '../../../../theme';
import {firstColWidth} from '../constants';

export function TotalsRow({totals}) {
  return (
    <StyledTableRow>
      <StyledBodyCell sx={{left: 0, position: 'sticky'}} />
      <StyledBodyCell sx={{left: firstColWidth, position: 'sticky'}} />
      {totals.map((amount, idx) => (
        <StyledBodyCell
          key={idx}
          sx={{
            textAlign: 'right',
            borderTop: `1px solid ${GREY_90}`,
            borderBottom: `3px double ${GREY_90}`,
          }}
        >
          <Typography>{renderAmount(amount)}</Typography>
        </StyledBodyCell>
      ))}
    </StyledTableRow>
  );
}

TotalsRow.propTypes = {
  totals: PropTypes.array.isRequired,
};
